import { required, requiredIf } from 'vuelidate/lib/validators';

export const nonZero = value => parseFloat(value) !== 0;

export const isGreaterThan = (minField, maxField) => (_, vm) => {
  const minValue = vm[minField];
  const maxValue = vm[maxField];
  const min = parseFloat(minValue);
  const max = parseFloat(maxValue);
  return isNaN(min) || isNaN(max) || max > min;
};

export const narrative = options => ({
  required: requiredIf(() => options && options.required),
  $each: {
    type: { required },
    background: {
      required: requiredIf(({ playerBackground }) => !playerBackground)
    },
    speaker: {
      required: requiredIf(({ type }) => (
        type &&
        ['dialog', 'leftDecisionBubble', 'rightDecisionBubble'].includes(type)
      ))
    },
    centerCharacter: {
      required: requiredIf(
        ({ type, centerPlayer, centerNarrator }) =>
          !centerPlayer && !centerNarrator && type && (type === 'animation' || type === 'exposition'))
    },
    text: {
      required: requiredIf(({ type, speaker }) => (
        type &&
        !['leftDecision', 'rightDecision'].includes(type) &&
        !(type === 'team' && !speaker === 'center')
      ))
    },
    video: {
      required: requiredIf(({ type }) => (
        type && type === 'video'
      ))
    }
  }
});



// WEBPACK FOOTER //
// ./src/utils/validators.js